/**
 * API Configuration
 * Centralized config for timeouts, retries, and rate limiting.
 */

export const API_CONFIG = {
  /** Default request timeout in ms */
  TIMEOUT: 30_000,

  /** Upload requests get a longer timeout */
  UPLOAD_TIMEOUT: 120_000,

  /** Max retries for failed requests (network errors & 5xx) */
  MAX_RETRIES: 2,

  /** Base delay between retries in ms (doubled each attempt) */
  RETRY_DELAY: 1_000,

  /** HTTP status codes that should trigger a retry */
  RETRYABLE_STATUS_CODES: [408, 429, 500, 502, 503, 504],

  /** HTTP methods safe to retry (idempotent) */
  RETRYABLE_METHODS: ["get", "head", "options", "put", "delete"],
} as const;
